module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-4.45d9ab75.png";